<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-8">
                <h4 class="m-b-0">Trace Report</h4>
                <p class="text-muted m-t-0">Click view to see information of report.</p>
            </div>
            <div class="col-4">

            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-6">
                            <b-form-group
                                    label="Filter"
                                    label-align-sm="right"
                                    label-cols-sm="1"
                                    label-for="filter-input"
                                    label-size="sm">
                                <b-input-group size="sm">
                                    <select class="form-control" id="exampleFormControlSelect1" v-model="filter">
                                        <option :key="registry_name" v-for="registry_name in registry_names">
                                            {{registry_name}}
                                        </option>
                                    </select>
                                    <select class="form-control ml-2" id="did_records" v-if="selected_registry"
                                            v-model="selected_definition_name">
                                        <option :key="definition_name" v-for="definition_name in definition_names">
                                            {{definition_name}}
                                        </option>
                                    </select>
<!--                                    <b-input-group-append>-->
<!--                                        <b-button class="float-right" @click="init()">Reset</b-button>-->
<!--                                        <b-button @click="init()">Reset</b-button>-->
<!--                                    </b-input-group-append>-->
                                </b-input-group>
                            </b-form-group>
                            </div>
                            <div class="col-md-6 float-right text-right">
                                <button aria-expanded="false" aria-haspopup="true"
                                        class="btn waves-effect waves-light btn-outline-info"
                                        data-toggle="dropdown" title="Operations">
                                    <i class="fa fa-grip-vertical"/>
                                </button>
                                <div class="dropdown-menu">
                                    <a class="dropdown-item" href="javascript:void(0)">
                                        <a @click="exportProcesses()" class="dropdown-item" href="javascript:void(0)">
                                            <i class="fa fa-file-excel"/> Export Delivery Notes
                                        </a>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <b-table :busy="busy" :current-page="currentPage" :fields="fields" :filter="filter"
                                 :items="processes"
                                 :per-page="perPage"
                                 :sort-by="sortBy" :sort-desc="sortDesc" :sort-direction="sortDirection"
                                 @filtered="onFiltered"
                                 responsive striped tbody-tr-class="rowClass"  v-if="processes.length>0">
                            <template #cell(created)="data">
                                {{ data.value | date }}
                            </template>
                            <template #cell(status)="data">
                                <p v-if="data.value === 'InProgress'"><span
                                        class="label label-primary">InProgress</span></p>
                                <p v-else-if="data.value === 'Completed'"><span
                                        class="label label-success">Completed</span></p>
                            </template>
                            <template #cell(process)="data">
                                <a :href="$BORLAUG + '/provenance/'+ data.value"
                                   target="_blank">
                                    <img class="bws-ico" src="@/assets/images/orange_bws_logo.png"> Borlaug</a>
                            </template>
<!--                            <template #cell(action)="data">-->
<!--                                <i class="text-dark-green font-18 fa fa-border fa-eye"-->
<!--                                   data-placement="top"-->
<!--                                   data-toggle="tooltip" style="cursor: pointer;"-->
<!--                                   title="Print Smart Card"></i>-->
<!--                            </template>-->
                        </b-table>
                        <template v-else>
                            <h4 class="card-title text-muted text-center m-t-30">No records found.</h4>
                            <h5 class="card-title text-muted text-center m-b-30">Change search criteria and try again</h5>
                        </template>
                        <div class="card-footer" v-if="totalRows>5">
                            <div class="row">
                                <div class="col">
                                    <per-page :total="totalRows" v-model="perPage"/>
                                </div>
                                <div class="col-auto" v-if="totalRows>perPage">
                                    <b-pagination :per-page="perPage" :total-rows="totalRows" v-model="currentPage"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Blockie from "../../../common/Blockie";
    import Paginate from 'vuejs-paginate';
    import PerPage from "@/components/protected/common/PerPage.vue";
    import moment from "moment";
    import XLSX from "xlsx";

    export default {
        name: "TraceReportList",
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        components: {Blockie, Paginate, PerPage},
        watch: {
            filter: async function (nv, ov) {
                if (nv) {
                    this.selected_registry = this.registries.find(c => c.name.trim() === nv.trim()).registry;
                    await this.getDefinitions(this.selected_registry);
                    this.selected_definition_name = this.definitions.length > 0 ? this.definitions[0].name : null;
                    this.selected_definition = this.definitions.length > 0 ? this.definitions[0].process_definition : null;
                    if (this.selected_definition) {
                        await this.getProcesses();
                    } else {
                        this.definitions = []
                    }

                }
            },
            selected_definition_name: function (nv, ov) {
                if (nv) {
                    this.selected_definition = this.definitions.find(c => c.name.trim() === nv.trim()).process_definition;
                    this.getProcesses();
                }
            }
        },
        data() {
            return {
                members: [],
                pageCount: 1,
                total: 0,
                member: {
                    id: null,
                    biz_name: null
                },
                catalogs: [],
                registry_names: [],
                processes: [],
                fields: [
                    {
                        key: 'registry_name',
                        label: 'Registry',
                    },
                    {
                        key: 'definition_name',
                        label: 'Definition',
                    },
                    {
                        key: 'name',
                        sortable: true
                    },
                    {
                        key: 'status',
                        sortable: true
                    },
                    {
                        key: 'created',
                        label: 'Created on',
                        sortable: true
                    },
                    {
                        key: 'process',
                        label: 'View on Explorer',
                    },
                    // {
                    //     key: 'action',
                    //     label: 'Action',
                    // }
                ],
                busy: false,
                currentPage: 1,
                perPage: 5,
                totalRows: 0,
                sortBy: 'name',
                sortDesc: false,
                sortDirection: 'asc',
                filter: null,
                selected_catalog: null,
                did_record_keys: [],
                did_record_key: null,
                did_record_value: null,
                calls: [],
                registries: [],
                definitions: [],
                definition_names: [],
                selected_registry: null,
                selected_definition: null,
                selected_definition_name: null
            };
        },
        mounted() {
            this.init();
        },
        methods: {
            async init() {
                await this.getRegistries();
                await this.getDefinitions();
                await this.getProcesses();
            },
            async getRegistries() {
                try {
                    let {data} = await this.$provenance.get(`/provenance/registries?page=0&per_page=1000`);
                    this.registries = data.registries;
                    this.registry_names = data.registries.map(cf => cf.name);
                    this.filter = data.registries.length > 0 ? data.registries[0].name : null;
                    this.selected_registry = data.registries.length > 0 ? data.registries[0].registry : null;
                } catch (e) {
                    console.error(e)
                }
            },
            async getDefinitions() {
                try {
                    let {data} = await this.$provenance.get(`/provenance/registries/${this.selected_registry}/definitions?page=0&per_page=1000`);
                    this.definitions = data.process_definitions;
                    this.definition_names = data.process_definitions.map(pd => pd.name);
                    this.selected_definition_name = this.definitions.length > 0 ? this.definitions[0].name : null;
                    this.selected_definition = this.definitions.length > 0 ? this.definitions[0].process_definition : null;
                } catch (e) {
                    console.error(e)

                }
            },
            async getProcesses() {
                try {
                    let {data} = await this.$provenance.get(`/provenance/registries/${this.selected_registry}/definitions/${this.selected_definition}/processes?page=0&per_page=1000`);
                    let self = this;
                    this.processes = data.processes.map(p => ({
                        ...p,
                        registry_name: self.filter,
                        definition_name: self.selected_definition_name
                    }));
                } catch (e) {
                    console.error(e)

                }
            },
            onFiltered(filteredItems) {
                console.log(filteredItems)
                this.totalRows = filteredItems.length
                this.currentPage = 1
            },
            async exportProcesses(page) {
                try {
                    this.exporting = true;
                    this.processes = this.processes.map(p=> ({
                        ...p,
                        created: moment(p.created, "YYYYY-MM-DDTHH:mm:SS").format("DD-MMM-YYYY HH:mm"),
                        completed_at: p.completed_at ? moment(p.completed_at, "YYYYY-MM-DDTHH:mm:SS").format("DD-MMM-YYYY HH:mm") : ''
                    }))
                    let workbook = XLSX.utils.book_new();
                    let delivery_note_sheet = XLSX.utils.json_to_sheet(this.processes);
                    XLSX.utils.book_append_sheet(workbook, delivery_note_sheet, 'Report');
                    XLSX.writeFile(workbook, 'Trace_Report.xlsx');
                } catch (e) {
                    console.error(e)
                    this.$toastr('error', 'Export failed', 'Failure');
                } finally {
                    this.exporting = false;
                }
            }

        }
    }
</script>

<style scoped>

</style>
